import Cookies, { type CookieAttributes } from 'js-cookie';

export const setCookie = (key: string, value: string, options?: CookieAttributes): string | undefined =>
  Cookies.set(key, value, { domain: '.cian.ru', path: '/', ...options });

export const getCookie = (key: string): string | undefined => Cookies.get(key);
